import {Container} from 'pixi.js';
import {Layer} from '@pixi/layers';

export function setLayer<T extends Container>(layer: Layer, ...elements: T[]): void {
    elements.forEach(element => {
        element.parentGroup = layer.group;
    });
}
